import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import iconDeleteTrash from "../../../assets/icon-delete-trash.svg";
import iconEditExternal from "../../../assets/icon-edit-external.svg";

type TaggingPlanRowActionsProps = Readonly<{
  onEdit: () => void;
  onDelete: () => void;
}>;

export default function TaggingPlanRowActions({
  onEdit,
  onDelete,
}: TaggingPlanRowActionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleDelete = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleCloseMenu();
    onDelete();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        gap: 0.25,
      }}
    >
      <IconButton
        aria-label="Edit plan row"
        size="small"
        sx={{ p: 0.75 }}
        onClick={(event) => {
          event.stopPropagation();
          onEdit();
        }}
      >
        <Box
          component="img"
          src={iconEditExternal}
          alt=""
          sx={{ width: 16, height: 16, display: "block" }}
        />
      </IconButton>
      <IconButton
        aria-label="More actions"
        size="small"
        sx={{ p: 0.75 }}
        onClick={handleOpenMenu}
      >
        <MoreVertIcon sx={{ fontSize: 18, color: "#A6A6A6" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: {
            sx: {
              minWidth: "auto",
              borderRadius: "8px",
              boxShadow:
                "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
            },
          },
        }}
      >
        <MenuItem
          onClick={handleDelete}
          sx={{
            color: "#E30000",
            py: 1,
            px: 1.5,
            gap: "4px",
            fontSize: "0.875rem",
            fontWeight: 500,
          }}
        >
          <Box
            component="img"
            src={iconDeleteTrash}
            alt=""
            sx={{ width: 16, height: 16, display: "block", flexShrink: 0 }}
          />
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
}
